/**
 * Versions config service to get versions config
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */

/**
 * Return versions config.
 * @returns - object with versions configured
 */
 module.exports.versionsConfig = function () {
	return {
		default: 'fmd',
        versions: [
            {
                version: 'fmd'
            },
            {
                version: 'galaxy'
            }
        ]
	};
}